
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-edit",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.217 1.438C28.335.55 27.113 0 25.763 0s-2.572.55-3.453 1.438L2.946 20.899c-.129.13-.226.292-.277.473l-.002.008-2.546 9.239c-.105.379.002.784.278 1.063.277.278.681.385 1.058.28l9.193-2.56c.181-.05.345-.147.478-.28L30.492 9.66a4.932 4.932 0 000-6.942l-1.274-1.279zM5.311 21.608L21.158 5.68l5.111 5.137L10.42 26.745l-5.111-5.137zM4.29 23.666l4.083 4.105-5.648 1.573 1.564-5.676zM28.957 8.118l-1.151 1.157-5.111-5.137 1.15-1.158c.49-.493 1.169-.799 1.919-.799s1.429.305 1.918.799l1.274 1.28c.49.495.793 1.176.793 1.929s-.303 1.434-.794 1.929z"}})])
          )
        }
      }
    